import React, { useEffect, useState, createRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCardSubtitle,
  CCardTitle,
  CCol,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CProgress,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CWidgetStatsA,
  CSmartTable,
} from '@coreui/react-pro'
import { CChartBar, CChartLine } from '@coreui/react-chartjs'
import { getStyle } from '@coreui/utils'
import CIcon from '@coreui/icons-react'
import {
  cibGoogle,
  cibFacebook,
  cibLinkedin,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cibTwitter,
  cilPeople,
  cilUser,
  cilUserFemale,
  cilArrowBottom,
  cilCart,
  cilArrowTop,
  cilUserPlus,
  cilOptions,
} from '@coreui/icons'

import * as cusUtil from 'src/viewsCommon/CusUtil'
// import DashboardCube from '../_company/dashboard/company/DashboardCube'
// import DashboardCubeAdmin from '../_company/dashboard/DashboardCubeAdmin'
// import DashboardCubeUser from '../_company/dashboard/DashboardCubeUser'

console.log('cid ', cusUtil.getCid())
const Dashboard = () => {
  // 쿠키 설정
  cusUtil.setCookie('isKiosk', 'n', 365)
  const cid = cusUtil.getCid()

  const DashboardCubeAdmin = require('../_company/dashboard/' +
    cid +
    '/DashboardCubeAdmin_' +
    cid).default
  const DashboardCubeUser = require('../_company/dashboard/' +
    cid +
    '/DashboardCubeUser_' +
    cid).default

  const userPermission = cusUtil.checkUserPermission()

  switch (userPermission) {
    case 'root':
    case 'admin':
    case 'cadmin':
    case 'cmanager':
      return <DashboardCubeAdmin />
    case 'user':
    default:
      return <DashboardCubeUser />
  }

  // if (cusUtil.getCid() !== '1') {
  //   return <DashboardCubeAdmin />
  // } else {
  //   return <DashboardCube />
  // }
}

export default Dashboard
